import axios from 'axios'
import clearInfo from './clearInfo'
import {
  Modal
} from 'view-design';
let data_error = false;
axios.defaults.timeout = 15000;
// axios.defaults.baseURL = 'https://www.youti99.com';
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  let TOKEN = localStorage.getItem('authorization')
  if (TOKEN) {
    config.headers.Authorization = TOKEN
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  if (response.data.code === 600) {
    if (!data_error) {
      alert(response.data.errors)
      data_error = true;
    }
    clearInfo()
    window.location.href = '/';
    return;
  } else if (response.data.code === 400) {
    Modal.error({
      title: '提示',
      content: response.data.errors
    });
  }
  return response;
}, function (error) {
  const {
    code,
    message
  } = error
  if (code === 'ECONNABORTED' || message === 'Network Error') { // 请求超时
    alert(`请求超时，请检查网络链接再重试`)
  }
  return Promise.reject(error);
});
export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js